module.exports = __webpack_public_path__ + "media/day/317-f4e044b5.svg";